export default {"src":"/_next/static/media/menuIcon.88b2b826.svg","height":23,"width":26};